import { useInfiniteQuery } from '@tanstack/react-query';
import { ApiCalls } from '../../../../api/api';
import { DateResolution } from '../../../../api/generated/data-contracts';

const getTakeParam = (pageOffset: number, chunkSize: number, overscan: number) => {
    if (pageOffset === 0) {
        // This is the initial call and we want to fill the whole screen,
        // and have another full page after that.
        // chunkSize is roughly equal to screen size
        return chunkSize * 2 + overscan;
    }

    return chunkSize;
};

export const useAllocationData = ({
    chunkSize,
    overscan,
    queryKey,
    timelineEnd,
    timelineResolution,
    timelineStart,
    grouping,
    projectId,
}: {
    chunkSize: number;
    overscan: number;
    queryKey: any[];
    timelineEnd: Date;
    timelineStart: Date;
    timelineResolution: DateResolution;
    grouping: string | null;
    projectId: string;
}) => {
    const query = useInfiniteQuery({
        queryKey,
        queryFn: async ({ pageParam, signal }) => {
			if (!signal.aborted) {
				return ApiCalls.getAllocationGrid(
					{
						query: {
							//
							skip: pageParam,
							take: getTakeParam(pageParam, chunkSize, overscan),
							// grouping,
						},
						dateResolution: timelineResolution,
						end: timelineEnd,
						start: timelineStart,
						projectId,
					},
					{ signal },
				).then(res => res.data);
			}
        },
        getNextPageParam: (lastGroup, allGroups, lastPageParam) => {
            if (!lastGroup.hasMore) {
                return null;
            }
            return lastPageParam + getTakeParam(lastPageParam, chunkSize, overscan);
        },
        initialPageParam: 0,
        enabled: chunkSize !== 0,
    });

    return query;
};
